import { Fragment } from "react";

import { useHistory } from "react-router-dom";
import BoxTitle from "../box/title/BoxTitle";

const Advertisement = ({ title, external, internal, img, bg }) => {
  const history = useHistory();
  return (
    <Fragment>
      <BoxTitle
        title={title}
        infoContext={""}
        externalLink={external}
        element={
          <i
            id="draggable"
            className="im im-icon-Double-Tap"
            style={{ fontSize: "32px", minWidth: "32px", cursor: "pointer" }}
          />
        }
      />
      <div style={{ marginTop: 30 }} />
      <div
        style={{
          height: "163px",
          aspectRatio: "1 / 1",
          objectFit: "cover",
          cursor: "pointer",
          marginInline: "auto",
          background: bg ?? "#f7e2e2",
          borderRadius: "50%",
        }}
      >
        <img
          src={img}
          alt={`${title} - image`}
          style={{ height: "100%", width: "100%" }}
          onClick={() => {
            if (external) window.open(`${external}`, "_blank");
            else if (internal) history.push(`/${internal}`);
          }}
        />
      </div>
    </Fragment>
  );
};
export default Advertisement;
